import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

const CalculatorResultContext = createContext({
  payload: null,
  result: null,
  setCalculatorData: () => {},
});

export const CalculatorResultProvider = ({ children }) => {
  const [data, setData] = useState({ payload: null, result: null });

  // Stable setter — never changes across renders so consumers can safely
  // include it in useEffect deps without infinite loops.
  const setCalculatorData = useCallback((payload, result) => {
    setData({ payload, result });
  }, []);

  const value = useMemo(() => ({
    payload: data.payload,
    result: data.result,
    setCalculatorData,
  }), [data, setCalculatorData]);

  return (
    <CalculatorResultContext.Provider value={value}>
      {children}
    </CalculatorResultContext.Provider>
  );
};

export const useCalculatorResult = () => useContext(CalculatorResultContext);
